<template>

  <div>
    <b-container>
      <b-row class="TitleArea">
          <b-col sm="12" lg="6">
              <h1 class="heading extraPad">Upcoming Tournaments</h1>
          </b-col>
          <b-col sm="12" lg="6" class="above769">
              <b-link to="/schedule" class="allNewsLink">
                  <button class="Allbuttons">
                      See Full Schedule
                  </button>
              </b-link>
          </b-col>
      </b-row>
      <div class="above769">
      <b-row v-if="showFutureEvents == true">
        <b-col sm="12" lg="4" class="upcomingTournaments" v-for="(upComingTours, index) in FutureEventFilter.slice(0, 3)" :key="index" >
            <div class="upcomingBlock" v-bind:style="{ 'background-image': 'url(' + fullNames[index] + ')'}">
            </div>
            <div class="textBlock">
              <div class="firstUpBlock">
                <div class="nameUpcoming">
                  {{upComingTours.full_name}} <span class="cancelled" v-if="upComingTours.cancelled == 'Y'">Cancelled</span>
                </div>
                <div class="datesUpcoming">
                  {{upComingTours.dic_dates}}
                </div>
              </div>
              <div class="moreDetailsDiv">
                <b-link :to="'/tournament' + '/' + upComingTours.code + '/' + Year" class="detailsText">
                  <button class="moreDetails">More Details</button>
                </b-link>
              </div>
              <div class="entiesClosedSec" v-if="upComingTours.is_closed == 'N'">
                Entries Close: {{upComingTours.closing_date}} - {{upComingTours.closing_time.slice(0,2)}}:{{upComingTours.closing_time.slice(2,4)}} (GST)
              </div>
            </div>
        </b-col>
      </b-row>
      <b-row v-else>
        <h2 class="noTournaments">No Upcoming Tournaments Available </h2>
      </b-row>
      </div>
      <div class="below769" >
        <vueper-slides
          style="display:none"
          class="no-shadow"
          :visible-slides="1"
          :gap="2"
          :arrows="false"
          :bullets="false"
          :autoplay="true"
          :duration="3000"
          :touchable="true"
          :slide-ratio="1/4"
          :infinite="true"
          :pauseOnTouch="false"
          :pauseOnHover="false"
          :dragging-distance="200">
          <vueper-slide v-for="(i, item) in FutureEventFilter" :key="item" :title="i.toString()" >
            <template #content>
            <div class="upcomingBlock" v-bind:style="{ 'background-image': 'url(' + fullNames[item] + ')'}">
            </div>
            <div class="textBlock">
              <div class="firstUpBlock">
                <div class="nameUpcoming">
                  {{i.full_name}} <span class="cancelled" v-if="i.cancelled == 'Y'">Cancelled</span>
                </div>
                <div class="datesUpcoming">
                  {{i.dic_dates}}
                </div>
              </div>
              <div class="moreDetailsDivMob">
                <b-link :to="'/tournament' + '/' + i.code + '/' + Year" class="detailsText">
                  <button class="moreDetails">More Details</button>
                </b-link>
              </div>
              <div class="entiesClosedSec" v-if="i.is_closed == 'N'">
                Entries Close: {{i.closing_date}} - {{i.closing_time.slice(0,2)}}:{{i.closing_time.slice(2,4)}} (GST)
              </div>
            </div>
            </template>
          </vueper-slide>
        </vueper-slides>
        <vueper-slides 
          :touchable="true"
          class="no-shadow"
          :visible-slides="1"
          :gap="2"
          :bullets="false"
          :arrows="false"
          :autoplay="true"
          :duration="3000"
          :slide-ratio="1 / 4"
          :infinite="true"
          :dragging-distance="70"
        >
          <vueper-slide v-for="(i, item) in FutureEventFilter" :key="item" :title="i.toString()" >
            <template #content>
            <div class="upcomingBlock" v-bind:style="{ 'background-image': 'url(' + fullNames[item] + ')'}">
            </div>
            <div class="textBlock">
              <div class="firstUpBlock">
                <div class="nameUpcoming">
                  {{i.full_name}} <span class="cancelled" v-if="i.cancelled == 'Y'">Cancelled</span>
                </div>
                <div class="datesUpcoming">
                  {{i.dic_dates}}
                </div>
              </div>
              <div class="moreDetailsDivMob">
                <b-link :to="'/tournament' + '/' + i.code + '/' + Year" class="detailsText">
                  <button class="moreDetails">More Details</button>
                </b-link>
              </div>
              <div class="entiesClosedSec" v-if="i.is_closed == 'N'">
                Entries Close: {{i.closing_date}} - {{i.closing_time.slice(0,2)}}:{{i.closing_time.slice(2,4)}} (GST)
              </div>
            </div>
            </template>
          </vueper-slide>
        </vueper-slides>

        <div sm="12" lg="6" class="mobSchedBut">
            <b-link to="/schedule" class="allNewsLink">
                <button class="Allbuttons">
                    See Full Schedule
                </button>
            </b-link>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
import apiCall from "@/services/api.js";
export default {
  name: "Upcoming Tournaments",
  props: ["Year", "config", "DEFIMAGESAMS3"],
  components: {
    VueperSlides, VueperSlide
  },
  data() {
    return {
      sliding: false,
      imgURL: this.config.VUE_APP_COURSE_URL,
      file: "File_1.jpg",
      upComingTours: [],
      img: this.config.VUE_APP_DEFAULT_COURSE,
      tournImage: '',
      showFutureEvents: ''
    };
  },
  computed: {
    FutureEventFilter: function() {
      console.log('in future events')
      return this.upComingTours.filter(
        (upComingTours) => upComingTours.days_away > 3
      );
    },
    slidesTotal:function(){
      return this.FutureEventFilter.length
    },
    // corrections start
    fullNames: function() {
        var Year = this.Year
        return this.FutureEventFilter.map(function(item) {
          if (item.course_image_file_1 == '') {
            console.log('blank')
            return 'https://ams3.digitaloceanspaces.com/ocs-sport/mena/2026/01/BG-min.jpg'
          } else {
            console.log('not blank')
            return 'https://tms-images.ams3.cdn.digitaloceanspaces.com/mena/courses/' + Year + '/' + item.course_code + '/' + item.course_image_file_1
          }
        });
    }
    // corrections end
  },
  methods: {
    replaceByDefault(e) {
      e.target.src = this.img;
    },
    checkForTourns : function() {
      if (this.FutureEventFilter.length > 0) {
        console.log('More then one event')
        this.showFutureEvents = true
      } else {
        console.log('There are no events')
        this.showFutureEvents = false
      }
    }
  },
  created() {
    apiCall
      .upComing(this.Year)
      .then(({ data }) => {
        this.upComingTours = data.tournaments.tournaments_entry;
        // this.TournamentBKimage();
        this.checkForTourns();
        this.loading = false;
      })
      .catch((error) => {
        console.log(error);
        throw error;
      });
  },
};
</script>

<style scoped>
.cancelled {
  background-color: #C8112E;
  color: #fff;
  padding: 5px;
  font-size: 15px;
  position: relative;
  top: -3px;
}
.entiesClosedSec {
  position: absolute;
  bottom: 0;
  font-size: 14px;
  padding-left: 6px;
  padding-bottom: 8px;
}
a.allNewsLink {
  text-decoration: none!important;
}
.mobSchedBut {
  position: relative;
  top: 10px;
}
.vueperslides {
  position: relative;
  height: 600px;
}
::v-deep .vueperslides__parallax-wrapper {
  position: relative;
  overflow: initial!important;
  height: 600px;
}
.upcomingTournaments:hover {
  transform: translateY(-10px);
}

.upcomingTournaments {
  transition: all 0.4s ease;
  /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
  transition: all 350ms cubic-bezier(.37, 0, .63, 1);
}
.firstUpBlock {
  padding-top: 2em;
  padding-left: 10px;
  padding-right: 10px;
}
::v-deep a.detailsText {
  text-decoration: none;
  color: #152229;
}
a.detailsText:hover > button{
  color: #fff!important;
  text-decoration: none!important;
}
.moreDetailsDiv {
  border: 1px solid #C8102E;
  border-radius: 26px;
  width: 206px;
  margin: auto;
  background-color: transparent;
  text-decoration: none!important;
  bottom: 55px;
  left: 0;
  right: 0;
  position: absolute;
}
.moreDetailsDiv:hover {
  border: 1px solid #C8102E;
  border-radius: 26px;
  width: 206px;
  margin: auto;
  background-color: #C8102E;
  color: #fff;
  text-decoration: none;
}
.moreDetails {
  border: none;
  display: block;
  margin: auto;
  background-color: transparent;
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: 16px;
  color: #152229;
}
h2.noTournaments {
  text-align: center;
  display: block;
  font-size: 36px;
  color: #C8102E;
  margin: auto;
}
.datesUpcoming {
  color: #C8102E;
  font-size: 28px;
  font-weight: bold;
  text-align: center;
}
.nameUpcoming {
  color: #152229;
  font-size: 28px;
  font-weight: bold;
  text-align: center;
}
.upcomingBlock {
  /* height: 500px; */
  height: 304px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  /* margin-right: 20px; */
  background-color: black;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}
.textBlock{
  background-color: #fff;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  height: 304px;
  border: 1px solid #E0E0E0;
}
.TitleArea {
  padding-bottom: 30px;
}
.paddingSpace {
  padding: 50px;
}
.Allbuttons {
  float: right;
  width: 244px;
  height: 50px;
  background: transparent;
  color: #152229;
  font-weight: 500;
  border-radius: 30px;
  border: 1px solid #C8102E;
  font-size: 16px;
  transition: all 0.4s ease;
  /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
  transition: all 350ms cubic-bezier(.37, 0, .63, 1);
}
.Allbuttons:hover {
  float: right;
  width: 244px;
  height: 50px;
  background: #C8102E;
  color: #fff;
  font-weight: 500;
  border-radius: 30px;
  border: 1px solid #E8E8E8;
  transform: translateY(-10px);
}
h1.heading.extraPad {
  /* padding: 20px; */
}
.heading{
  font-weight: 600;
  font-size: 40px;
  color: #C8102E;
  padding-bottom: 10px;
}
::v-deep .bslide > .slick-list > .slick-track > .slick-slide {
  width: 100%!important;
  display: contents;
}
.sponLogo {
  /* background: #fff; */
  /* padding: 40px; */
  /* margin-right: 20px; */
}
p.moreInfo-btn.tournlink {
  background-color: #C8102E;
  width: 200px;
  text-align: center;
  color: #fff;
  /* border-radius: 10px; */
  padding: 0.5rem 1rem;
}
::v-deep .bslide > .slick-list > .slick-track > .slick-slide {
  width: 100%!important;
}
::v-deep .bslide > .slick-list > .slick-track{
  display: flex;
  overflow: scroll;
  width: 100%!important;
  height: inherit;
}
::v-deep a {
  color: black;
}
img.logo {
  max-width: 136px;
  float: right;
  padding-right: 45px;
  margin-top: -100px;
}

.courseImg {
  width: 100%;
}
::v-deep .slick-slider > button {
  display: none !important;
}
.backImg {
  background-repeat: no-repeat !important;
  background-size: cover !important;
  height: 415px !important;
}
.minibackImg {
  background-color: lightgrey;
  background-repeat: no-repeat !important;
  background-size: cover !important;
  height: 76px;
}
::v-deep .slick-slide > div > div > img {
  opacity: 0.5;
}
::v-deep .slick-current > div > div > img {
  opacity: 1;
}
.cap {
  position: absolute;
  color: white;
  padding-left: 4%;
  text-align: left;
  color: #ffffff;
  background-color: rgba(38, 48, 86, 0.7);
  top: -300px;
  padding-top: 20px;
  height: 225px;
  left: 15px;
  right: 58%;
}
::v-deep .slick-list {
  position: relative;
  display: block;
  margin: 0;
  padding: 0;
  transform: translateZ(0);
  box-shadow: 0 1px 4px rgb(0 0 0 / 20%);
}
::v-deep .bslide > .slick-list {
  height: 150px;
}

.tourName {
  font-size: 14px;
  color: #C8102E;
  margin-bottom: 2px;
  padding-left: 10px;
  padding-right: 10px;
  white-space: nowrap;
  width: 175px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}
.tourNameTwo {
  color: #d3d3d3;
  white-space: nowrap;
  width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}
.mobile {
  display: none;
}

@media only screen and (max-width: 1200px) {
  .upcomingBlock:before {
    content: "";
    position: absolute;
    overflow: hidden;
    /* border-radius: 50px; */
    width: 91%;
    height: 50%;
    bottom: 0;
    /* background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.4)); */
    border-bottom-left-radius: 50px;
    border-bottom-right-radius: 50px;
  }
}
@media only screen and (max-width: 1281px) {
  img.logo {
    max-width: 136px;
    float: right;
    padding-right: 45px;
    margin-top: -100px;
  }
}
@media only screen and (max-width: 990px) {
  .Allbuttons {
    float: none;
    width: 244px;
    height: 50px;
    background: transparent;
    color: #152229;
    font-weight: 500;
    border-radius: 30px;
    border: 1px solid #C8102E;
    font-size: 16px;
    margin-top: 30px;
    transition: all 0.4s ease;
    /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
    transition: all 350ms cubic-bezier(.37, 0, .63, 1);
  }
  .Allbuttons:hover {
    float: none;
    width: 244px;
    height: 50px;
    background: #C8102E;
    color: #fff;
    font-weight: 500;
    border-radius: 30px;
    border: 1px solid #E8E8E8;
    margin-top: 30px;
    transform: translateY(-10px);
  }
  .upcomingTournaments.col-sm-12.col-lg-4 {
    margin-bottom: 30px;
  }
}
@media only screen and (max-width: 900px) {
  .Allbuttons {
    float: none;
    width: 244px;
    height: 50px;
    background: transparent;
    color: #152229;
    font-weight: 500;
    border-radius: 30px;
    border: 1px solid #C8102E;
    font-size: 16px;
    margin-top: 30px!important;
    margin: auto;
    display: block;
    transition: all 0.4s ease;
    /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
    transition: all 350ms cubic-bezier(.37, 0, .63, 1);
  }
  .Allbuttons:hover {
    float: none;
    width: 244px;
    height: 50px;
    background: #C8102E;
    color: #fff;
    font-weight: 500;
    border-radius: 30px;
    border: 1px solid #E8E8E8;
    margin-top: 30px!important;
    margin: auto;
    display: block;
    transform: translateY(-10px);
  }
  .upcomingTournaments {
    padding-top: 15px;
  }
  #slider {
    display: none;
  }
  .mobile {
    display: block;
    padding: 20px 0;
  }
  ::v-deep .mobCap > .carousel-caption {
    bottom: 0px;
    background-color: rgba(38, 48, 86, 0.7);
    margin: auto;
  }
  ::v-deep .img-fluid {
    height: 180px;
  }
  ::v-deep .mobCap > .carousel-caption > a{
    color:#fff!important;
  }
  .heading {
    font-weight: 600;
    font-size: 40px;
    color: #C8102E;
    text-align: center;
    margin-top: 30px;
  }
  /* .Allbuttons {
    float: none;
    width: 244px;
    height: 50px;
    background: transparent;
    color: #C8102E;
    font-weight: 500;
    border-radius: 30px;
    border: 1px solid #E8E8E8;
    margin: auto;
    display: block;
    margin-top: 30px;
  } */
}
@media only screen and (max-width: 500px) {
  ::v-deep .img-fluid {
    height: 130px;
  }
  ::v-deep .mobCap > .carousel-caption{
    bottom:10px;
  }
  .upcomingBlock:before {
    content: "";
    position: absolute;
    overflow: hidden;
    /* border-radius: 50px; */
    width: 94%!important;
    height: 50%;
    bottom: 0;
    /* background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.4)); */
    border-bottom-left-radius: 50px;
    border-bottom-right-radius: 50px;
  }
}
@media only screen and (min-width: 769px) {
  .below769 {
    display: none;
  }
}
@media only screen and (max-width: 769px) {
  .above769 {
    display: none;
  }
  .moreDetailsDivMob {
    border: 1px solid #C8102E;
    border-radius: 26px;
    width: 206px;
    margin: auto;
    background-color: transparent;
    text-decoration: none !important;
    left: 0;
    right: 0;
    position: relative;
    top: 40px;
  }
  .moreDetailsDivMob:hover {
    border: 1px solid #C8102E;
    border-radius: 26px;
    width: 206px;
    margin: auto;
    background-color: #C8102E;
    text-decoration: none !important;
    left: 0;
    right: 0;
    position: relative;
    top: 40px;
    color: #fff;
  }
  .firstUpBlock {
    padding-top: 4em;
    padding-left: 50px;
    padding-right: 50px;
  }
}
@media only screen and (max-width: 510px) {
  .nameUpcoming {
    color: #152229;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
  }
  .datesUpcoming {
    color: #C8102E;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
  }
}
</style>
